export function apiErrorMessage(error, fallback) {
  const detail = error?.response?.data?.detail;
  if (Array.isArray(detail)) {
    const message = detail
      .map((item) => (item?.msg || "").replace(/^Value error,\s*/, ""))
      .filter(Boolean)
      .join("; ");
    return message || fallback;
  }
  if (typeof detail === "string") return detail;
  if (detail && typeof detail === "object" && typeof detail.message === "string") return detail.message;
  return fallback;
}
